import { render } from "./MusubiJourneyRibbon.vue?vue&type=template&id=7ef7da34&scoped=true"
import script from "./MusubiJourneyRibbon.vue?vue&type=script&lang=js"
export * from "./MusubiJourneyRibbon.vue?vue&type=script&lang=js"

import "./MusubiJourneyRibbon.vue?vue&type=style&index=0&id=7ef7da34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef7da34"]])

export default __exports__